export const BUILDING_TYPE_PROJECT = 'project';
export const BUILDING_TYPE_NEW_BUILDING = 'new_building';
export const BUILDING_TYPE_COTTAGE = 'cottage';
